import { Component } from '@angular/core';

import { AppLauncherStateService } from './app-launcher-state.service';

/**
 * Standalone App Launcher application shell.
 *
 * Renders the persistent header + feedback widget and switches between the
 * top-level steps of the pilot experience (landing, account, My Apps, the
 * App Launcher app view, and the expanded-access painted door). The app view
 * embeds the real `central-web-apps-wc` web component from central-ui.
 */
@Component({
	selector: 'al-root',
	templateUrl: './app.component.html',
})
export class AppComponent {
	constructor(public readonly state: AppLauncherStateService) {}
}
